



const current_weather = [

]


const current_weather_icons = {
    fill: {
        "uv-index": require('images/weather-icons/fill/uv-index.svg'),                   
        "thermometer": require('images/weather-icons/fill/thermometer.svg'),
        "thermometer-colder": require('images/weather-icons/fill/thermometer-colder.svg'),
        "thermometer-warmer": require('images/weather-icons/fill/thermometer-warmer.svg'),
        "thermometer-mercury-cold": require('images/weather-icons/fill/thermometer-mercury-cold.svg'),
        "humidity": require('images/weather-icons/fill/humidity.svg'),
        "raindrops": require('images/weather-icons/fill/raindrops.svg'),
        "barometer": require('images/weather-icons/fill/barometer.svg'),
        "clear-sky-day": require('images/weather-icons/fill/clear-day.svg'),
        "o-meteo-wc-0": require('images/weather-icons/fill/clear-night.svg'),
        "o-meteo-wc-1": require('images/weather-icons/fill/cloudy.svg'),
        "o-meteo-wc-2": require('images/weather-icons/fill/partly-cloudy-day.svg'),
        "o-meteo-wc-3": require('images/weather-icons/fill/overcast.svg'),
        "o-meteo-wc-45": require('images/weather-icons/fill/haze-day.svg'),
        "o-meteo-wc-48": require('images/weather-icons/fill/haze-day.svg'),
        "o-meteo-wc-51": require('images/weather-icons/fill/partly-cloudy-day-drizzle.svg'),
        "o-meteo-wc-53": require('images/weather-icons/fill/partly-cloudy-day-drizzle.svg'),
        "o-meteo-wc-55": require('images/weather-icons/fill/partly-cloudy-day-drizzle.svg'),
        "o-meteo-wc-56": require('images/weather-icons/fill/partly-cloudy-day-drizzle.svg'),
        "o-meteo-wc-57": require('images/weather-icons/fill/partly-cloudy-day-drizzle.svg'),
        "o-meteo-wc-61": require('images/weather-icons/fill/partly-cloudy-day-rain.svg'),
        "o-meteo-wc-63": require('images/weather-icons/fill/partly-cloudy-day-rain.svg'),
        "o-meteo-wc-65": require('images/weather-icons/fill/partly-cloudy-day-rain.svg'),
        "o-meteo-wc-66": require('images/weather-icons/fill/partly-cloudy-day-sleet.svg'),
        "o-meteo-wc-67": require('images/weather-icons/fill/partly-cloudy-day-sleet.svg'),
        "o-meteo-wc-71": require('images/weather-icons/fill/partly-cloudy-day-snow.svg'),
        "o-meteo-wc-73": require('images/weather-icons/fill/partly-cloudy-day-snow.svg'),
        "o-meteo-wc-75": require('images/weather-icons/fill/partly-cloudy-day-snow.svg'),
        "o-meteo-wc-77": require('images/weather-icons/fill/snowflake.svg'),
        "o-meteo-wc-80": require('images/weather-icons/fill/rain.svg'),
        "o-meteo-wc-81": require('images/weather-icons/fill/rain.svg'),
        "o-meteo-wc-82": require('images/weather-icons/fill/rain.svg'),
        "o-meteo-wc-85": require('images/weather-icons/fill/snow.svg'),
        "o-meteo-wc-86": require('images/weather-icons/fill/snow.svg'),
        "o-meteo-wc-95": require('images/weather-icons/fill/thunderstorms.svg'),
        "o-meteo-wc-96": require('images/weather-icons/fill/thunderstorms-day-rain.svg'),
        "o-meteo-wc-99": require('images/weather-icons/fill/thunderstorms-day-snow.svg'),

        ow_weathercodes: {
            "01d": require('images/weather-icons/fill/openweather-weathercodes/01d.svg'),
            "01n": require('images/weather-icons/fill/openweather-weathercodes/01n.svg'),
            "02d": require('images/weather-icons/fill/openweather-weathercodes/02d.svg'),
            "02n": require('images/weather-icons/fill/openweather-weathercodes/02n.svg'),
            "03d": require('images/weather-icons/fill/openweather-weathercodes/03d.svg'),
            "03n": require('images/weather-icons/fill/openweather-weathercodes/03n.svg'),
            "04d": require('images/weather-icons/fill/openweather-weathercodes/04d.svg'),
            "04n": require('images/weather-icons/fill/openweather-weathercodes/04n.svg'),
            "09d": require('images/weather-icons/fill/openweather-weathercodes/09d.svg'),
            "09n": require('images/weather-icons/fill/openweather-weathercodes/09n.svg'),
            "10d": require('images/weather-icons/fill/openweather-weathercodes/10d.svg'),
            "10n": require('images/weather-icons/fill/openweather-weathercodes/10n.svg'),
            "11d": require('images/weather-icons/fill/openweather-weathercodes/11d.svg'),
            "11n": require('images/weather-icons/fill/openweather-weathercodes/11n.svg'),
            "13d": require('images/weather-icons/fill/openweather-weathercodes/13d.svg'),
            "13n": require('images/weather-icons/fill/openweather-weathercodes/13n.svg'),
            "50d": require('images/weather-icons/fill/openweather-weathercodes/50d.svg'),
            "50n": require('images/weather-icons/fill/openweather-weathercodes/50n.svg'),
        }
    },
    line: {
        "thermometer-mercury-cold": require('images/weather-icons/outline/thermometer-mercury-cold.svg'),
        ow_weathercodes: {
    
        }
    }
}


let a = 4;
let b = 5;


export { a, b, current_weather_icons };